import React from 'react';
export function FaqSection() {
  const faqs = [{
    q: '¿Necesito que mi pareja sea muy abierta para jugar?',
    a: "No, el juego está diseñado para que incluso los más 'cerrados' participen por curiosidad."
  }, {
    q: '¿Cuánto tiempo toma?',
    a: 'Cada caso toma entre 15 y 20 minutos.'
  }, {
    q: '¿Es físico o digital?',
    a: 'Es un PDF de descarga inmediata para que jueguen hoy mismo.'
  }, {
    q: '¿Sirve para novios o solo casados?',
    a: 'Sirve para cualquier relación que quiera fortalecer su complicidad.'
  }];
  return <section className="py-20 bg-noir-bg border-b border-noir-border" data-id="element-47">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-48">
        <h2 className="text-3xl font-mono font-bold text-noir-text mb-10 text-center uppercase" data-id="element-49">
          Interrogatorio <span className="text-noir-alert" data-id="element-50">Frecuente</span>
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="bg-noir-card border border-noir-border p-6 rounded-sm" data-id="element-52">
              <h4 className="text-base font-mono font-bold text-noir-text mb-2 uppercase" data-id="element-53">
                Q: {faq.q}
              </h4>
              <p className="text-noir-muted text-sm" data-id="element-54">A: {faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}